import CarColors from "./partials/basic_color_list.json";

export const getCarColor = (hexCode: string) => {
    return CarColors.filter((color) => color.value === hexCode)
        .map((color) => color.name)
        .join(", ");
};
